// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
    background-color: #007bff; /* Blue background I added to check format */
    height: 100vh;
    width: 100vw;
    display: flex;
}
/* General Container */
.container {
    display: flex;
    height: 100vh;
    width: 80vw;
    font-family: "Poppins", Arial, sans-serif;
}

/* Centered Image */
.center-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 250px; 
    height: auto;
    opacity: 0.8; 
}

/* Image to the Right */
.right-image {
    position: absolute;
    right: 0px;
    top: 0;
    width: 50vw;
    height: 100vh; 
    object-fit: cover;
}


/* Left Section */
.left-section {
    width: 55%;
    height: 85vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    padding: 4rem; 
}


.logo {
    font-size: 2rem;
    font-weight: bold;
}

.subtitle {
    margin-top: 10px;
    font-size: 1.2rem;
    color: #666;
}

.title {
    margin-top: 10px;
    font-size: 1.8rem;
    font-weight: bold;
}

.form-container {
    width: 100%;
    max-width: 400px; 
    margin-top: 20px;
}

.label {
    display: block;
    margin-bottom: 5px;
    font-size: 0.9rem;
    color: #444;
}

.input {
    width: 93%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
    margin-bottom: 15px;
}

.btn {
    width: 100%;
    padding: 12px;
    background-color: #007bff;
    color: white;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
}

.btn:hover {
    background-color: #0056b3;
}

.or-text {
    margin-top: 15px;
    color: #666;
}

.social-icons {
    display: flex;
    gap: 10px;
    margin-top: 10px;
}

.social-btn {
    width: 40px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 50%;
    font-size: 1rem;
    cursor: pointer;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
}

.social-btn:hover {
    background-color: #f0f0f0;
}

.signup-text {
    margin-top: 20px;
}

.link {
    color: #007bff;
    text-decoration: none;
}

.link:hover {
    text-decoration: underline;
}


/* Logo Styling */
.logo-img {
    width: 220px; 
    height: auto;
    position: absolute;
    top: 20px;
    left: 20px;
}

/* Sign In Button */
.btn {
    width: 100%;
    padding: 12px;
    background-color: #007bff;
    color: white;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px; 
    margin-bottom: 15px; 
}

.btn:hover {
    background-color: #0056b3;
}

/* Google Sign-In Button */
.google-btn {
    width: 100%;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background-color: white;
    color: black;
    font-size: 1rem;
    font-weight: 500;
    border: 1px solid #ccc;
    border-radius: 8px;
    cursor: pointer;
    margin-top: 10px; 
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.google-btn:hover {
    background-color: #f5f5f5;
}


/* Google Icon */
.google-icon {
    width: 20px;
    height: 20px;
}

.link:hover{
    cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/styles/Login2.css"],"names":[],"mappings":"AACA;IACI,yBAAyB,EAAE,4CAA4C;IACvE,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;AACA,sBAAsB;AACtB;IACI,aAAa;IACb,aAAa;IACb,WAAW;IACX,yCAAyC;AAC7C;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;;AAGA,iBAAiB;AACjB;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;;AAGA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA,iBAAiB;AACjB;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,gBAAgB;AAChB;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');\n.login-page {\n    background-color: #007bff; /* Blue background I added to check format */\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n}\n/* General Container */\n.container {\n    display: flex;\n    height: 100vh;\n    width: 80vw;\n    font-family: \"Poppins\", Arial, sans-serif;\n}\n\n/* Centered Image */\n.center-image {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 250px; \n    height: auto;\n    opacity: 0.8; \n}\n\n/* Image to the Right */\n.right-image {\n    position: absolute;\n    right: 0px;\n    top: 0;\n    width: 50vw;\n    height: 100vh; \n    object-fit: cover;\n}\n\n\n/* Left Section */\n.left-section {\n    width: 55%;\n    height: 85vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: white;\n    padding: 4rem; \n}\n\n\n.logo {\n    font-size: 2rem;\n    font-weight: bold;\n}\n\n.subtitle {\n    margin-top: 10px;\n    font-size: 1.2rem;\n    color: #666;\n}\n\n.title {\n    margin-top: 10px;\n    font-size: 1.8rem;\n    font-weight: bold;\n}\n\n.form-container {\n    width: 100%;\n    max-width: 400px; \n    margin-top: 20px;\n}\n\n.label {\n    display: block;\n    margin-bottom: 5px;\n    font-size: 0.9rem;\n    color: #444;\n}\n\n.input {\n    width: 93%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 1rem;\n    margin-bottom: 15px;\n}\n\n.btn {\n    width: 100%;\n    padding: 12px;\n    background-color: #007bff;\n    color: white;\n    font-size: 1rem;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n}\n\n.btn:hover {\n    background-color: #0056b3;\n}\n\n.or-text {\n    margin-top: 15px;\n    color: #666;\n}\n\n.social-icons {\n    display: flex;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.social-btn {\n    width: 40px;\n    height: 40px;\n    border: 1px solid #ccc;\n    border-radius: 50%;\n    font-size: 1rem;\n    cursor: pointer;\n    background-color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.social-btn:hover {\n    background-color: #f0f0f0;\n}\n\n.signup-text {\n    margin-top: 20px;\n}\n\n.link {\n    color: #007bff;\n    text-decoration: none;\n}\n\n.link:hover {\n    text-decoration: underline;\n}\n\n\n/* Logo Styling */\n.logo-img {\n    width: 220px; \n    height: auto;\n    position: absolute;\n    top: 20px;\n    left: 20px;\n}\n\n/* Sign In Button */\n.btn {\n    width: 100%;\n    padding: 12px;\n    background-color: #007bff;\n    color: white;\n    font-size: 1rem;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px; \n    margin-bottom: 15px; \n}\n\n.btn:hover {\n    background-color: #0056b3;\n}\n\n/* Google Sign-In Button */\n.google-btn {\n    width: 100%;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    background-color: white;\n    color: black;\n    font-size: 1rem;\n    font-weight: 500;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    cursor: pointer;\n    margin-top: 10px; \n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease;\n}\n\n.google-btn:hover {\n    background-color: #f5f5f5;\n}\n\n\n/* Google Icon */\n.google-icon {\n    width: 20px;\n    height: 20px;\n}\n\n.link:hover{\n    cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
